export enum FailedAction {
  deploy = 'deploy',
  create = 'create',
  save = 'save',
  delete = 'delete',
  activate = 'activate',
  deactivate = 'deactivate',
}
